<style type="text/css">
.blog_table_footer {
    display: flex;
    box-sizing: content-box;
    padding-top: 10px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    justify-content: space-between;
}
</style>
<template>
    <div>
        <div style="display: flex;justify-content: flex-start;margin-top:20px">
            <el-input placeholder="通过标题搜索该分类下的产品..." prefix-icon="el-icon-search" v-model="keywords" style="width: 400px"></el-input>
            <el-button type="primary" icon="el-icon-search" size="mini" style="margin-left: 3px" @click="searchClick">搜索</el-button>
            <el-select v-model="value" style="margin-left: 20px" @change="handleSelectChange" placeholder="通过类型搜索改分类下的产品...">
                <el-option v-for="item in options" :key="item.id" :label="item.productName" :value="item.id"></el-option>
            </el-select>
            <el-button type="primary" style="margin-left: 20px" @click="addProduct">添加商品</el-button>
        </div>
        <el-table
            ref="multipleTable"
            :data="productLists"
            tooltip-effect="dark"
            style="width: 100%;overflow-x: hidden; overflow-y: hidden;"
            max-height="600"
            @selection-change="handleSelectionChange"
        >
            <el-table-column label="序号" type="index" width="55" align="center"></el-table-column>
            <el-table-column label="标题" width="140" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span style="color: #409eff;cursor: pointer" @click="itemClick(scope.row)">{{ scope.row.title }}</span>
                </template>
            </el-table-column>
            <el-table-column label="最近编辑时间" width="140" align="center">
                <template slot-scope="scope">{{ scope.row.date | formatDateTime }}</template>
            </el-table-column>
            <el-table-column label="产品图片" width="200" align="center">
                <template slot-scope="scope">
                    <el-popover placement="top" width="200" trigger="hover">
                        <img slot="reference" :src="scope.row.product_image" style="width: 140px; height: 60px" />
                        <img style="max-width: 200px" :src="scope.row.product_image" />
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column label="所属分类" width="120" align="center">
                <template slot-scope="scope">{{ scope.row.category }}</template>
            </el-table-column>
            <el-table-column label="操作" align="left">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="blog_table_footer">
            <!-- <el-button
                type="danger"
                size="mini"
                style="margin: 0px;"
                :disabled="this.selItems.length == 0"
                @click="deleteMany"
                >批量删除</el-button
            > -->
            <span></span>
            <el-pagination
                background
                :page-size="pageSize"
                layout="prev, pager, next"
                :total="totalCount"
                @current-change="currentChange"
                v-show="this.productLists.length > 0"
            ></el-pagination>
        </div>
        <el-dialog :title="dialogTitle + '商品'" :visible.sync="dialogVisible" width="440px" @close="resetForm">
            <el-form :model="productForm" status-icon ref="productForm" label-width="70px">
                <el-form-item label="标题" prop="title">
                    <el-input v-model="productForm.title"></el-input>
                </el-form-item>
                <el-form-item label="类名" prop="category" align="left">
                    <el-select v-model="productForm.category" placeholder="请选择当前产品所属分类..">
                        <el-option v-for="item in options" :key="item.id" :label="item.productName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="产品图片" prop="product_image" align="left">
                    <el-upload
                        class="avatar-uploader"
                        ref="upload"
                        action=""
                        accept="image/jpeg,image/png,image/jpg"
                        :before-upload="onBeforeUploadImage"
                        :http-request="UploadImage"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove"
                    >
                        <img v-if="imgUrl" :src="imgUrl" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="dialogTitle == '新增'" type="primary" @click="submitForm">提交</el-button>
                    <el-button v-else type="primary" @click="editorForm">确定</el-button>
                    <!-- <el-button @click="resetForm('productForm')">重置</el-button> -->
                    <el-button @click="resetForm">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog :visible.sync="dialogImageVisible">
            <img width="100%" :src="productForm.product_image" alt />
        </el-dialog>
    </div>
</template>

<script>
import { putRequest, getRequest, postRequest, uploadFileRequest } from '@/utils/api';
import md5 from 'js-md5';
export default {
    data() {
        return {
            limit: 1,
            dialogTitle: '新增',
            imgUrl: '',
            productLists: [],
            selItems: [],
            currentPage: 1,
            totalCount: -1,
            pageSize: 6,
            keywords: '',
            dustbinData: [],
            options: [],
            value: '',
            dialogVisible: false,
            dialogImageVisible: false,
            productForm: {
                title: '',
                category: '',
                product_image: '',
            },
            editorId: '',
        };
    },
    mounted: function() {
        this.loadBlogs(1, this.pageSize);
        this.getProductCate();
    },
    methods: {
        resetForm() {
            this.dialogVisible = false;
            this.imgUrl = '';
            for (const [key, value] of Object.entries(this.productForm)) {
                this.productForm[key] = '';
            }
        },
        addProduct() {
            this.dialogTitle = '新增';
            this.dialogVisible = true;
        },
        onBeforeUploadImage(file) {
            const isIMAGE = file.type === 'image/jpeg' || 'image/jpg' || 'image/png';
            const isLt1M = file.size / 1024 / 1024 < 2;
            if (!isIMAGE) {
                this.$message.error('上传文件只能是图片格式!');
            }
            if (!isLt1M) {
                this.$message.error('上传文件大小不能超过 2MB!');
            }
            return isIMAGE && isLt1M;
        },
        UploadImage(param) {
            const formData = new FormData();
            formData.append('image', param.file);
            // this.productForm.product_image = formData;
            uploadFileRequest('/uploadimg', formData)
                .then(result => {
                    const { code, message, data } = result.data;
                    this.imgUrl = data;
                    this.productForm.product_image = data;
                })
                .catch(error => {
                    this.errorInfo('图片上传失败');
                });
        },
        getProductCate() {
            getRequest('/product/category/all').then(
                resp => {
                    this.options = resp.data.data;
                },
                resp => {
                    if (resp.response.status == 403) {
                        this.$message({
                            type: 'error',
                            message: resp.response.data,
                        });
                    }
                }
            );
        },

        handleSelectChange(value) {
            postRequest('/product/search', { pid: value }).then(response => {
                const {
                    data: {
                        code,
                        message,
                        data: { data, totalCount },
                    },
                } = response;
                if (code === 200) {
                    this.productLists = data;
                    this.totalCount = totalCount;
                } else {
                    this.failedInfo('数据加载失败!');
                }
            });
        },
        getOptions(id) {
            return this.options.find(value => value.id === id).productName;
        },

        submitForm() {
            const { title, category, product_image } = this.productForm;
            if (title === '' || title === null) {
                return this.failedInfo('标题不得为空');
            }
            if (category === '' || category === null) {
                return this.failedInfo('请选择产品分类');
            }

            if (product_image === '' || product_image === null) {
                return this.failedInfo('请上传产品图片');
            }
            const productName = this.getOptions(category);
            postRequest('/product/add', {
                title,
                pid: category,
                product_image,
                category: productName,
            }).then(result => {
                const { code } = result.data;
                if (code === 200) {
                    this.successInfo('上传成功');
                    this.dialogVisible = false;
                    this.loadBlogs(1, this.pageSize);
                } else {
                    this.failedInfo('上传失败');
                }
            });
        },
        editorForm() {
            const { title, category, product_image } = this.productForm;
            if (title === '' || title === null) {
                return this.failedInfo('标题不得为空');
            }
            if (category === '' || category === null) {
                return this.failedInfo('请选择产品分类');
            }

            if (product_image === '' || product_image === null) {
                return this.failedInfo('请上传产品图片');
            }
            const productName = this.getOptions(category);
            postRequest('/product/update', {
                id: this.editorId,
                title,
                pid: category,
                product_image,
                category: productName,
            }).then(result => {
                const { code } = result.data;
                if (code === 200) {
                    this.successInfo('更新成功');
                    this.dialogVisible = false;
                    this.loadBlogs(1, this.pageSize);
                } else {
                    this.failedInfo('更新失败');
                }
            });
        },
        searchClick() {
            postRequest('/product/search/key', {
                keywords: this.keywords,
            }).then(result => {
                const { code, message, data } = result.data;
                if (code === 200) {
                    this.productLists = data;
                    this.successInfo('获取成功');
                } else {
                    this.errorInfo('获取数据信息错误');
                }
            });
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => {});
        },
        itemClick(row) {
            postRequest('/productDetail/find', { lid: row.id })
                .then(result => {
                    const { code, message, data } = result.data;
                    if (code === 200) {
                        if (data) {
                            this.$confirm('产品参数已存在,是否前往查看？', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                            }).then(() => {
                                this.$router.push({
                                    path: '/productDetail',
                                    query: { lid: row.id, pid: row.pid },
                                });
                            });
                        } else {
                            this.$confirm('暂未添加产品参数,是否前往编辑？', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                            }).then(() => {
                                this.$router.push({
                                    path: '/editProductDetail',
                                    query: {
                                        lid: row.id,
                                        pid: row.pid,
                                        isStatus: 0,
                                    },
                                });
                            });
                        }
                    }
                    code: 200;
                    message: 'SUCCESS';
                    data: null;
                })
                .catch(() => {
                    this.failedInfo('获取数据信息错误');
                });
        },
        deleteMany() {
            var selItems = this.selItems;
            for (var i = 0; i < selItems.length; i++) {
                this.dustbinData.push(selItems[i].id);
            }
            this.deleteToDustBin();
        },
        //翻页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.loadBlogs(currentPage, this.pageSize);
        },
        handleRemove(file, fileList) {
            // console.log(file, fileList);
        },
        handlePictureCardPreview(file) {
            this.productForm.product_image = file.url;
            this.dialogImageVisible = true;
        },
        loadBlogs(page, count) {
            postRequest('/product/all', { count, page })
                .then(
                    result => {
                        const {
                            code,
                            data: { data, totalCount },
                        } = result.data;
                        if (code == 200) {
                            this.productLists = data;
                            this.totalCount = totalCount;
                        } else {
                            this.failedInfo('数据加载失败!');
                        }
                    },
                    result => {
                        const { status, data } = result.response;
                        if (status == 403) {
                            this.failedInfo(data);
                        } else {
                            this.failedInfo('数据加载失败!');
                        }
                    }
                )
                .catch(resp => {
                    this.failedInfo('数据加载失败!');
                });
        },
        handleSelectionChange(val) {
            this.selItems = val;
        },
        handleEdit(row) {
            for (const [key, value] of Object.entries(this.productForm)) {
                this.productForm[key] = row[key];
            }
            this.productForm.category = row.pid;
            this.imgUrl = row.product_image;
            this.editorId = row.id;
            this.dialogTitle = '编辑';
            this.dialogVisible = true;
        },
        handleDelete(row) {
            this.dustbinData.push(row.id);
            this.deleteToDustBin(row);
        },
        deleteToDustBin(row) {
            var _this = this;
            this.$confirm('永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    if (row.product_image) {
                        this.deleteImage(row);
                    }
                    postRequest('/product/delete', {
                        id: _this.dustbinData,
                    }).then(
                        resp => {
                            _this.dustbinData = [];
                            _this.successInfo('删除成功!');
                            this.loadBlogs(1, this.pageSize);
                        },
                        resp => {
                            _this.failedInfo('删除失败!');
                            _this.dustbinData = [];
                        }
                    );
                })
                .catch(() => {
                    _this.errorInfo('已取消删除');
                    _this.dustbinData = [];
                });
        },

        deleteImage(row) {
            const key = row.product_image;
            const path = key.slice(key.lastIndexOf('/') + 1, key.length);
            postRequest('/deleteimg', { filename: path }).then(res => {
                // console.log(res);
            });
        },
        errorInfo(info) {
            this.$message({ type: 'info', message: info });
        },
        successInfo(info) {
            this.$message({ type: 'success', message: info });
        },
        failedInfo(info) {
            this.$message({ type: 'error', message: info });
        },
    },
};
</script>
<style scoped>
.avatar-uploader {
    width: 150px;
    height: 150px;
    border-radius: 5px;
    border: solid 1px #d6d9e2;
}
.el-upload {
    border-radius: 5px;
    cursor: pointer;
    width: 150px;
    height: 150px;
    position: relative;
    overflow: hidden;
}
.el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
}
.avatar {
    width: 150px;
    height: 150px;
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/product/productList.vue